import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

//import main scss file
import '../../../css/styleGuide/legacyStyleGuide.scss';

//import main module definition.
import toastModule from '../toast/toastModule';
importFilesUnderPath(require.context("../toast/directives/", true, /\.js$/));
let templateContext = require.context("../toast/", true, /\.html$/);
templateCacheGenerator(angular, 'toastHtmlTemplate', templateContext);

import infiniteScrollModule from '../infiniteScroll/infiniteScrollModule';
importFilesUnderPath(require.context("../infiniteScroll/directives/", true, /\.js$/));

import verticalMenuModule from '../verticalMenu/verticalMenuModule';
importFilesUnderPath(require.context("../verticalMenu/directives/", true, /\.js$/));
